import { useCallback, useState } from 'react';
import { useMqttSubscription } from './useMqttSubscription';

const MAX_MESSAGES = 200;

// Sniffs every message published under a unit's topic tree. Only active
// while `enabled` is true, mirroring useRfidReader: the modal's open state
// drives the MQTT subscription lifecycle (connect on open, disconnect on close).
export const useMqttSniffer = (unitId, enabled) => {
  const [messages, setMessages] = useState([]);

  const topics = enabled && unitId ? [`${unitId}/#`] : [];

  const handleMessage = useCallback((topic, payload) => {
    let text;
    try {
      text = atob(payload.toString());
    } catch {
      text = payload.toString();
    }
    setMessages((prev) => {
      const next = [...prev, { topic, payload: text, timestamp: Date.now() }];
      return next.length > MAX_MESSAGES ? next.slice(next.length - MAX_MESSAGES) : next;
    });
  }, []);

  const { isConnected } = useMqttSubscription(topics, handleMessage);

  const reset = useCallback(() => {
    setMessages([]);
  }, []);

  return { messages, isConnected, reset };
};
